import React from 'react';
import './styles.css';
import Header from './components/Header';
import Video from './components/Video';
import Course from './components/Course';
import Learn from './components/Learn';
import Testimonials from './components/Testimonials';
import Tutor from './components/Tutor';
import Footer from './components/Footer';


function App() {
  return (
    <div className="app overflow-y-hidden bg-gray-100">
        <Header />
        <Video />
        <Course />
        <Learn />
        <Testimonials />
        <Tutor />
        <Footer />
    </div>
  );
}

export default App;
